import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ITableCellModel, ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { getExcludeValues, mergeMultiItemValues } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import * as shapeValues from '@src/slide/application/service/menu-manager/menu-values/shape';
import _set from 'lodash/set';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: ITableModel): { [key: string]: any } {
    // 聚合子元素的菜单值获取，有缓存优先读取缓存
    const mergeMenuValuesCache = getMenuManager()?.mergeMenuValuesCacheMap.get(model);
    if (mergeMenuValuesCache) {
        return mergeMenuValuesCache;
    }
    const itemValueArray: any[] = [];
    const selectedModels: ITableCellModel[] = [];
    for (let i = 0; i < model.selectedCellRanges.length; i++) {
        const cellRange = model.selectedCellRanges[i];
        const shapeModel = model.tableItems[cellRange.rowStart][cellRange.colStart];
        const values = shapeValues.getMenuValues(shapeModel);
        itemValueArray.push(values);
        selectedModels.push(shapeModel);
    }
    const mergedValues = mergeMultiItemValues(itemValueArray, getExcludeValues(selectedModels));
    const { borderStyle, borderColor } = model.getBorder().getTableBorderInfo();
    _set(mergedValues, ActionType.BORDERSTYLE, borderStyle);
    _set(mergedValues, ActionType.BORDERCOLOR, borderColor);
    _set(mergedValues, ActionType.MERGE_CELL, model.selectOneMergedCell());
    return mergedValues;
}

function getMenuManager(): IMenuManager | undefined {
    return (AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices).editableServiceLayer?.menuManager;
}

